
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';

const LogoutButton = ({ children, className, onClick }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        // Call custom onClick if provided
        if (onClick) {
            onClick();
        }

        const userRole = await logout();

        // Redirect based on user role
        if (userRole === 'seller') {
            navigate('/seller/login', { replace: true });
        } else if (userRole === 'superadmin' || userRole === 'admin') {
            navigate('/admin/login', { replace: true });
        } else {
            navigate('/', { replace: true });
        }
    };

    // Alpha function for transparency
    const alpha = (color, opacity) => {
        const hex = color.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    };

    return (
        <button
            onClick={handleLogout}
            className={className}
            style={{
                padding: '8px 16px',
                display: 'flex',
                alignItems: 'center',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                width: '100%',
                borderRadius: '4px',
                transition: 'background-color 0.2s ease',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = alpha('#EF4444', 0.08);
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
            }}
        >
            <LogoutIcon style={{ fontSize: '16px', color: '#EF4444', marginRight: '12px' }} />
            <span style={{ fontSize: '12px', fontWeight: 500, color: '#EF4444' }}>
                {children || 'Logout'}
            </span>
        </button>
    );
};

export default LogoutButton;